import { useCallback } from "react";

const useMultiSelectOnChange = <T>(onChange: (value: T[]) => void) =>
  useCallback(
    (val: T[] | T) => {
      onChange(Array.isArray(val) ? val : [val]);
    },
    [onChange]
  );

export default useMultiSelectOnChange;
